import React from "react";

import YellowActiveStar from "../../assets/images/front/YellowActiveStar@2x.png";
import YellowStar from "../../assets/images/front/YellowStar@2x.png";
import styled from "styled-components";

// interface StarsProps {
//   numberOfStars: number | string;
//   color?: 'blue' | 'yellow';
//   onChange?: (stars: number) => void;
// }

export default function Stars({ numberOfStars, color = "blue", onChange }){
  const stars = Array.from({ length: 5 }, (_, index) => {
    const isActive = index + 1 <= numberOfStars;
    return (
      <li key={index} className={`rating-item ${isActive ? "active" : ""}`}>
        {color === "yellow" && (
          <img
            onClick={() => onChange && onChange(index + 1)}
            src={isActive ? YellowActiveStar : YellowStar}
            alt=''
            width='22'
            height='22'
          />
        )}
        {color === "blue" && <RatingStar>&nbsp;</RatingStar>}
      </li>
    );
  });

  return (
    <VoteRating>
      <VoteRatingList>{stars}</VoteRatingList>
    </VoteRating>
  );
};


const RatingStar = styled.a`
  display: inline-block;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  background: url(../images/front/sprite-star.png) no-repeat 0 0 scroll;
  background-size: 22px 66px;
  -webkit-background-size: 22px 66px;
`;

const VoteRating = styled.div`
  text-align: right;
  margin-top: 8px;
  min-width: 130px;
`;
const VoteRatingList = styled.ul`
  display: inline-block;
  list-style: none;
  padding: 0;
  margin: 0;
  .rating-item {
    padding-left: 4px;
    display: inline-block;
    vertical-align: middle;
  }
`;
